




import { Component, Vue } from "vue-property-decorator";

@Component
export default class TalkToMeJr extends Vue {}

const component = TalkToMeJr;
